module.exports = __webpack_public_path__ + "img/project2.74be83b6.jpeg";